import React, { Component } from 'react';

export default class RiskProfileSlide extends Component {
  answers;

  constructor(props){
    super(props);

    this.onRadioButtonClicked = this.onRadioButtonClicked.bind(this);

    this.answers = this.props.question.answers.map((answer,index) => {
      return (
        <label key={index} className="form-control" htmlFor={`form-${this.props.question.id}-value-${answer.value}`}>
          <input className="radio_buttons required"
            type="radio" value={answer.value} name="radio"
            id={`form-${this.props.question.id}-value-${answer.value}`}
            onClick={()=>{this.onRadioButtonClicked(answer)}}/>
          <span className="form-control__indicator"></span>
          <span className="form-control__label">{answer.text}</span>
        </label>
      )
    })
  }

  onRadioButtonClicked(answer){
    this.props.onRadioButtonClicked(this.props.question, answer);
  }

  render(){
    return (
      <div className="">
        <h2>{this.props.question.question}</h2>
        <div className="form-control__controls">
          <form className="onboarding__form radio_buttons risk-radios" id={`risk-form-${this.props.question.id}`}>
            <fieldset className="form__inputs">
              <div className="form-input radio_buttons required">
                <fieldset className="form-controls">
                  <div className="form-controls__controls">
                    <input type="hidden" name="" value="" />
                    {this.answers}
                  </div>
                </fieldset>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    );
  }
}
